import {
    COVERAGE_DETAILS_REQUEST,
    COVERAGE_DETAILS_RESULT,
    COVERAGE_DETAILS_OPEN_MODAL,
    COVERAGE_DETAILS_CLOSE_MODAL,
    COVERAGE_DETAILS_GET_DEVICE_REQUEST,
    COVERAGE_DETAILS_GET_DEVICE_RESULT,
    COVERAGE_DETAILS_SET_DEVICE,
} from 'Redux/actionTypes';

export const coverageDetailsRequest = (data) => ({
    type: COVERAGE_DETAILS_REQUEST,
    payload: data
})

export const coverageDetailsResult = (result) => ({
    type: COVERAGE_DETAILS_RESULT,
    payload: result
})

export const coverageDetailsOpenModal = (id) => ({
    type: COVERAGE_DETAILS_OPEN_MODAL,
    payload: id
})

export const coverageDetailsCloseModal = () => ({
    type: COVERAGE_DETAILS_CLOSE_MODAL
})

export const coverageDetailsGetDeviceRequest = (item) => ({
    type: COVERAGE_DETAILS_GET_DEVICE_REQUEST,
    payload: item
})

export const coverageDetailsGetDeviceResult = (result) => ({
    type: COVERAGE_DETAILS_GET_DEVICE_RESULT,
    payload: result
})

export const coverageDetailsSetDevice = (device) => ({
    type: COVERAGE_DETAILS_SET_DEVICE,
    payload: device
})